import { render, staticRenderFns } from "./EmailandPasswordConfirm.vue?vue&type=template&id=68780a06&"
import script from "./EmailandPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailandPasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports